import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import './styles/Rooms.css';
import './styles/Tariff.css';
// import './styles/Location.css';
import './styles/Links.css';
import './styles/Map.css';
// import Rooms from './components/Bookings';
// import Tariff from './components/Tariff';
// import Location from 
import Links from './components/Links';
import Map from './components/Map';
import Apartments from './components/Apartments';
import Brora from './components/Brora';
import Cairn from './components/Cairn';
import Kinloch from './components/Kinloch';
import Parking from './components/Parking';

const App: React.FC = () => {
  const [navOpen, setNavOpen] = useState(false);
  return (
    <Router>
      <div className="app">
        <header>
          <div className="logo-container">
            <img 
              src={`${process.env.PUBLIC_URL}/images/aaron_glen_guest_apartments.gif`} 
              alt="Aaron Glen Guest Apartments Edinburgh" 
              width="487" 
              height="48" 
            />
          </div>
          <button className="hamburger" aria-label="Toggle navigation" onClick={() => setNavOpen(o => !o)}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div id="navcontainer">
            <ul className={navOpen ? 'open' : ''} onClick={() => setNavOpen(false)}>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/apartments">Apartments</Link></li>
              <li><Link to="/brora">Brora</Link></li>
              <li><Link to="/cairn">Cairn</Link></li>
              <li><Link to="/kinloch">Kinloch</Link></li>
              <li><Link to="/map">Map</Link></li>
              <li><Link to="/parking">Parking</Link></li>
              <li><Link to="/links">Links</Link></li>
            </ul>
          </div>
        </header>

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apartments" element={<Apartments />} />
            <Route path="/brora" element={<Brora />} />
            <Route path="/cairn" element={<Cairn />} />
            <Route path="/kinloch" element={<Kinloch/>} />
            <Route path="/map" element={<Map />} />
            <Route path="/links" element={<Links />} />
            <Route path="/parking" element={<Parking />} />
          </Routes>
        </main>

        <footer>
          <div className="footer-content">
            <div className="secret-logo">
              <a href="https://www.secret-scotland.com" target="_blank" rel="noopener noreferrer">
                <img 
                  src={`${process.env.PUBLIC_URL}/images/Secret-Scotland-Recommended.png`} 
                  alt="Secret Scotland Recommended" 
                  width="100" 
                  height="100" 
                />
              </a>
            </div>
            <div className="contact-info">
              <p>Carolyn and Les Davidson</p>
              <p>Aaron Glen Guest Apartments</p>
              <p>7 Nivensknowe Road, Loanhead, Midlothian EH20 9AU</p>
              <p>Email: <a href="mailto:carolyn@aaronglen.com">carolyn@aaronglen.com</a></p>
              <p>Telephone: 00 44 (0) 131 440 1293</p>
            </div>
            <div className="footer-links">
              <Link to="/">Home</Link> | 
              <Link to="/rooms">Accommodation and Breakfast</Link> | 
              <Link to="/tariff">Rates and Booking</Link> | 
              {/* <Link to="/location">Location</Link> |  */}
              <Link to="/map">Map</Link> | 
              <Link to="/links">Links</Link>
            </div>
            <div className="footer-bottom">
              <p>This page last updated {new Date().toLocaleDateString()}</p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
};

const Home: React.FC = () => {
  return (
    <div className="home-content">
      <div className="image-section">
        <img 
          src={`${process.env.PUBLIC_URL}/images/front_door.gif`} 
          alt="mirror in Aaron Glen Guesthouse" 
          width="400" 
          height="295" 
        />
      </div>
      <div className="features-section">
        <h1>Welcome to Aaron Glen Guest Apartments</h1>
        <h2>Luxury Self-Catering Accommodation in South Edinburgh</h2>

        <p>
          Experience stylish, flexible living at Aaron Glen Guest Apartments — a collection of 
          <strong> newly refurbished 1 and 2 bedroom luxury apartments</strong>, perfectly located in South Edinburgh.
        </p>

        <p>
          Each apartment is designed with your comfort and convenience in mind. Relax in bedrooms featuring 
          <strong> Egyptian cotton bed linen</strong>, and enjoy the privacy of <strong>en-suite bathrooms</strong> in every room. 
          Our spacious, <strong>fully fitted kitchens</strong> come equipped with everything you need, including a 
          <strong> fridge/freezer, Nespresso machine, washer/dryer</strong>, and all essential cookware and utensils.
        </p>

        <p>
          Unwind in the lounge with a <strong>55-inch Smart TV</strong>, or enjoy a morning coffee in the <strong>outdoor seating area</strong>. 
          Whether you're visiting for work or leisure, our apartments offer the space, freedom, and modern amenities 
          to feel right at home.
        </p>

        <h3>Amenities include:</h3>
        <ul>
          <li><strong>Free WiFi</strong> in all apartments</li>
          <li><strong>Large private car park</strong> for guests</li>
          <li><strong>Outdoor seating area</strong> for relaxing in the fresh air</li>
          <li>Only a <strong>1-minute walk to the nearest bus stop</strong> for direct access to Edinburgh city centre</li>
          <li><strong>Three large supermarkets</strong> within a 4-minute drive</li>
          <li>Just <strong>2 minutes from the Edinburgh City Bypass</strong> — ideal for exploring <em>Loch Lomond</em>, 
              <em> St Andrews</em>, <em>The Borders</em>, and <em>Glasgow</em></li>
        </ul>

        <p>
          With a reputation for <strong>consistently high guest reviews</strong>, Aaron Glen Guest Apartments has become a favourite 
          for those seeking quality self-catering accommodation with a personal touch.
        </p>

        <p>
          Whether you're planning a short break or an extended stay, Aaron Glen Guest Apartments is the ideal base 
          to explore Edinburgh and beyond — with all the comfort and independence of your own private space.
        </p>
      </div>
    </div>
  );
};

export default App; 

// Welcome to Aaron Glen Guest Apartments
// Luxury Self-Catering Accommodation in South Edinburgh

// Experience stylish, flexible living at Aaron Glen Guest Apartments — a collection of newly refurbished 1 and 2 bedroom luxury apartments, perfectly located in South Edinburgh.

// Each apartment is designed with your comfort and convenience in mind. Relax in bedrooms featuring Egyptian cotton bed linen, and enjoy the privacy of en-suite bathrooms in every room. Our spacious, fully fitted kitchens come equipped with everything you need, including a fridge/freezer, Nespresso machine, washer/dryer, and all essential cookware and utensils.

// Whether you're here for a weekend escape or a longer stay, you’ll enjoy all the essentials of home, with the quality of a boutique hotel.

// Amenities include:
// Free WiFi in all apartments

// Large private car park for guests

// Outdoor seating area for relaxing in the fresh air

// Only a 1-minute walk to the nearest bus stop for direct access to Edinburgh city centre

// Three large supermarkets within a 4-minute drive

// Just 2 minutes from the Edinburgh City Bypass — ideal for exploring Loch Lomond, St Andrews, The Borders, and Glasgow

// At Aaron Glen Guest Apartments, you’ll enjoy the space to unwind, the freedom to cook and dine on your own schedule, and a convenient base to explore everything Edinburgh and Scotland have to offer.